import { Component } from '@angular/core';

import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import dayjs from 'dayjs';

@Component({
	selector: 'formly-field-input',
	template: `
		<vp-date-picker
			[calendarData]="props['calendarData'] || null"
			[config]="{
				defaultDate: props['defaultDate'] || null,
				minDate: props['minDate'] || today,
				maxDate: props['maxDate'] || null,
				showMonths: props['showMonths'] || 1,
			}"
			[formControl]="formControl"
			[hasError]="showError"
			[initialValue]="formControl.value"
			[inputConfig]="{
				disabled: props.disabled,
				icon: props['icon'],
				iconPosition: props['iconPosition'],
				isValid: formControl.valid,
				name: field.id,
				placeholder: props.placeholder,
				readonly: props.readonly,
				defaultStyle: props['defaultStyle'] || true,
				required: props.required,
			}"
			[inputId]="field.id"
			[isLoading]="props['isLoading']"
			[isOptional]="props['optional']"
			[labelSettings]="{
				text: null,
				position: null,
			}"
			ngDefaultControl
		/>
	`,
	standalone: false,
})
export class DateInputComponent extends FieldType<FieldTypeConfig> {
	today: string = dayjs().format('YYYY-MM-DD');
}
